
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { AfterSaveContext, ClassMetadata, DocumentSearchCriteria, ExecutionResult, GridMetadata, IDocument, IJournalEntryServiceTemplateHelper, IMetadataAction, JournalEntryCreationContext, JournalEntryWithPacketCreationContext, LoadAllocationContext } from "@tylertech/tyler-api-types";

/**
 * JournalEntryService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class JournalEntryService<TJournalEntry = unknown, TDistribution = unknown> {
    constructor(private readonly $apiService: ApiService) { }
    
    CopyGLJournalEntry(copyId: string): Promise<TJournalEntry> {
        return this.$apiService.sendAuth("IJournalEntryService/CopyGLJournalEntry", copyId);
    }
    CopyGLJournalEntryWeb(copyId: string): Promise<AfterSaveContext> {
        return this.$apiService.sendAuth("IJournalEntryService/CopyGLJournalEntryWeb", copyId);
    }
    CreateAndSetupJournalEntry(pContext: JournalEntryCreationContext): Promise<TJournalEntry> {
        return this.$apiService.sendAuth("IJournalEntryService/CreateAndSetupJournalEntry", pContext);
    }
    CreateAndSetupJournalEntryWithSingleToAccountDist(pContext: JournalEntryWithPacketCreationContext): Promise<TJournalEntry> {
        return this.$apiService.sendAuth("IJournalEntryService/CreateAndSetupJournalEntryWithSingleToAccountDist", pContext);
    }
    CreateFromAllocations(pModel: LoadAllocationContext): Promise<ExecutionResult<string>> {
        return this.$apiService.sendAuth("IJournalEntryService/CreateFromAllocations", pModel);
    }
    CreateJournalEntryFromTemplate(journalEntryServiceTemplateHelper: IJournalEntryServiceTemplateHelper): Promise<TJournalEntry> {
        return this.$apiService.sendAuth("IJournalEntryService/CreateJournalEntryFromTemplate", journalEntryServiceTemplateHelper);
    }
    CreateNewGLJournalEntry(): Promise<TJournalEntry> {
        return this.$apiService.sendAuth("IJournalEntryService/CreateNewGLJournalEntry");
    }
    CreateNewGLJournalEntryDistribution(journalEntry: TJournalEntry): Promise<TDistribution> {
        return this.$apiService.sendAuth("IJournalEntryService/CreateNewGLJournalEntryDistribution", journalEntry);
    }
    CreateNewWebJournalEntry(): Promise<IMetadataAction> {
        return this.$apiService.sendAuth("IJournalEntryService/CreateNewWebJournalEntry");
    }
    DeleteGLJournalEntry(journalEntryId: string): Promise<void> {
        return this.$apiService.sendAuth("IJournalEntryService/DeleteGLJournalEntry", journalEntryId);
    }
    GenerateNewCashTransactionNumber(distribution: TDistribution): Promise<string> {
        return this.$apiService.sendAuth("IJournalEntryService/GenerateNewCashTransactionNumber", distribution);
    }
    GenerateNewGLJournalEntryNumber(): Promise<string> {
        return this.$apiService.sendAuth("IJournalEntryService/GenerateNewGLJournalEntryNumber");
    }
    GetDocumentSearchCriteria(journalEntryId: TJournalEntry): Promise<DocumentSearchCriteria> {
        return this.$apiService.sendAuth("IJournalEntryService/GetDocumentSearchCriteria", journalEntryId);
    }
    GetGLJournalEntry(filterString?: string): Promise<TJournalEntry[]> {
        return this.$apiService.sendAuth("IJournalEntryService/GetGLJournalEntry", null, filterString);
    }
    GetGLJournalEntryDistributionCashTransactionsViewMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IJournalEntryService/GetGLJournalEntryDistributionCashTransactionsViewMetadata");
    }
    GetGLJournalEntryDistributionReceiptViewMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IJournalEntryService/GetGLJournalEntryDistributionReceiptViewMetadata");
    }
    GetGLJournalEntryDistributionTableMetadata(): Promise<GridMetadata> {
        return this.$apiService.sendAuth("IJournalEntryService/GetGLJournalEntryDistributionTableMetadata");
    }
    GetGLJournalEntryMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IJournalEntryService/GetGLJournalEntryMetadata");
    }
    GetOutstandingGLJournalEntries(filterString?: string): Promise<TJournalEntry[]> {
        return this.$apiService.sendAuth("IJournalEntryService/GetOutstandingGLJournalEntries", null, filterString);
    }
    GetOutstandingGLJournalEntryTableMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IJournalEntryService/GetOutstandingGLJournalEntryTableMetadata");
    }
    Import(input: any): Promise<TJournalEntry> {
        return this.$apiService.sendAuth("IJournalEntryService/Import", input);
    }
    OpenImport(): Promise<IMetadataAction> {
        return this.$apiService.sendAuth("IJournalEntryService/OpenImport");
    }
    PostGLJournalEntry(journalEntryId: string): Promise<void> {
        return this.$apiService.sendAuth("IJournalEntryService/PostGLJournalEntry", journalEntryId);
    }
    ReverseGLJournalEntry(journalEntryId: string): Promise<TJournalEntry> {
        return this.$apiService.sendAuth("IJournalEntryService/ReverseGLJournalEntry", journalEntryId);
    }
    ReverseGLJournalEntryWeb(journalEntryId: string): Promise<AfterSaveContext> {
        return this.$apiService.sendAuth("IJournalEntryService/ReverseGLJournalEntryWeb", journalEntryId);
    }
    RunReport(pJournalEntryId: string): Promise<IDocument> {
        return this.$apiService.sendAuth("IJournalEntryService/RunReport", pJournalEntryId);
    }
    SaveGLJournalEntry(journalEntry: TJournalEntry): Promise<TJournalEntry> {
        return this.$apiService.sendAuth("IJournalEntryService/SaveGLJournalEntry", journalEntry);
    }
    SaveGLJournalEntryForImport(journalEntry: TJournalEntry): Promise<TJournalEntry> {
        return this.$apiService.sendAuth("IJournalEntryService/SaveGLJournalEntryForImport", journalEntry);
    }
}
